import { useQuery } from "@tanstack/react-query";
import { getAnalyticsDashboard } from "../api/analytics-api";

export const useAnalyticsDashboard = () => {
	return useQuery({
		queryKey: ["analytics", "dashboard"],
		queryFn: getAnalyticsDashboard,
		staleTime: 5 * 60 * 1000, // 5 minutes
		refetchOnWindowFocus: false
	});
};
